// Google Tag Manager + GA4 placeholders
// Replace GTM-XXXXXXX and G-XXXXXXX with your real IDs.
export const GTM_ID = 'GTM-XXXXXXX';
export const GA_MEASUREMENT_ID = 'G-XXXXXXX';

// Optionally push custom events:
export const trackEvent = (name, params = {}) => {
  if (window && window.dataLayer) {
    window.dataLayer.push({ event: name, ...params });
  }
};

// Initialize defaults
if (!window.dataLayer) window.dataLayer = [];
window.dataLayer.push({ event: 'app_initialized' });
